const LANG = 'lang';
const DEFAULT_LANG = 'pl';

export default {
  getLang() {
    return window.localStorage.getItem(LANG);
  },

  setLang(language) {
    window.localStorage.setItem(LANG, language);
  },

  setDefaultLang() {
    window.localStorage.setItem(LANG, DEFAULT_LANG);
  },

  destroyLang() {
    window.localStorage.removeItem(LANG);
  },
};



// WEBPACK FOOTER //
// ./src/services/lang.service.js